/**
 * Strip HTML tags from a raw HTML string and return visible text content.
 * Uses DOMParser — safe for browser-only use.
 */
export function extractTextFromHtml(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Remove script, style, nav, footer, header, aside nodes
  const noiseTags = ['script', 'style', 'nav', 'footer', 'header', 'aside', 'noscript'];
  for (const tag of noiseTags) {
    doc.querySelectorAll(tag).forEach((el) => { el.remove(); });
  }

  return (doc.body?.textContent ?? '').replace(/\s+/g, ' ').trim();
}
